import React, { useState, useRef, useEffect, useCallback } from "react";
import axios from "axios";
import content from "../../includes/content";
import StyledFSS from "./styles";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { Helmet } from "react-helmet";
import PageOne from "../../components/pageOne";
import PageTwo from "../../components/pageTwo";
import PageThree from "../../components/pageThree";
import PageFour from "../../components/pageFour";
import Popup from "../../components/Popup";
import Header from "../../components/header";
import { getMetaDescription, siteVersion } from "../../utils";
const Registration = () => {
  const initialData = {
    firstName: "Customer",
    lastName: "",
    loanNumber: "",
    email: "",
    token: "",
    ssn: "",
  };
  const [data, setData] = useState(initialData);
  const [pageOne, setPageOne] = useState(true);
  const [pageTwo, setPageTwo] = useState(false);
  const [pageThree, setPageThree] = useState(false);
  const [pageFour, setPageFour] = useState(false);
  const [pageFive, setPageFive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [canvas, setCanvas] = useState(null);
  const [publicToggle, setPublicToggle] = useState(false);
  const [loan, setLoan] = useState({});
  const [saveCustom, setSaveCustom] = useState(false);
  const [error, setError] = useState({ status: false, message: "" });
  const [modalText, setModalText] = useState("");
  const [initialURL, setInitialURL] = useState("");
  const [tempURL, setTempURL] = useState("");
  const [customURL, setCustomURL] = useState("");
  const [loadError, setLoadError] = useState(false);
  const captureRef = useRef(null);
  const urlTernary = `${customURL === "" ? initialURL : customURL}`;
  const metaUrl = `${process.env.REACT_APP_CERT_REDIRECT}${process.env.REACT_APP_BASENAME}`;
  const metaThumbnail = process.env.REACT_APP_THUMBNAIL;
  const metaDescription = `Secure your Future with your ${process.env.REACT_APP_TITLE} by Sun West Mortgage Company, Inc.`;
  const metaTitle = `${process.env.REACT_APP_TITLE} - Sun West Mortgage Company, Inc. - Housing America Since 1980`;
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const hashkey = queryParams.get("key") || null;
    const handleHashkey = async () => {
      if (hashkey) {
        try {
          const { data: hashData } = await axios.get(
            `${process.env.REACT_APP_SUNSOFT_RESTSERVER_KEY}${hashkey}`
          );

          if (hashData) {
            const { loanNumber, firstName, email, lastName } =
              hashData.parameters;
            const { token } = hashData;
            setData((prev) => ({
              ...prev,
              loanNumber,
              firstName,
              lastName,
              email,
              token,
            }));
          }
        } catch (err) {
          console.log(err);
          setLoadError(true);
          setLoading(true);
          setModalText(
            <>
              <strong>Sorry, something went wrong.</strong>
              <br />
              The hashkey in the url could be either incorrect or expired.
              <br /> If you've viewed this page previously please follow the
              link provided to you.
              <br />
              <a href="https://www.swmc.com/">Click here to go back.</a>
            </>
          );
        }
      } else {
        setLoadError(true);
        setLoading(true);
        setModalText(
          <>
            <strong>Sorry, you are not authorized to view this page.</strong>
            <br /> If you've viewed this page previously please follow the link
            provided to you.
            <br />
            <a href="https://www.swmc.com/">Click here to go back.</a>
          </>
        );
      }
    };
    handleHashkey();
  }, []);

  useEffect(() => {
    if (pageOne || pageTwo || pageThree || pageFour) {
      window.scrollTo(0, 0);
    }
  }, [pageOne, pageTwo, pageThree, pageFour]);

  const client = async ({ url, method, body }) => {
    let clientData;
    try {
      const config = {
        method,
        url,
        headers: {
          "Session-Token": data.token,
        },
        data: body,
      };
      clientData = await axios(config);
    } catch (err) {
      console.log(err.response, "error in catch");
      clientData = err;
    } finally {
      return clientData;
    }
  };

  const validateSSN = (ssnNumber, userSSN) => {
    const arr = ssnNumber.split("");
    const number = arr
      .splice(arr.length - 4, 5)
      .join()
      .replaceAll(",", "");

    if (
      number === `${userSSN.one}${userSSN.two}${userSSN.three}${userSSN.four}`
    ) {
      return true;
    }
    return false;
  };

  const authenticateUser = async () => {
    let clientResponse;
    try {
      const url = `${process.env.REACT_APP_SUNSOFT_RESTSERVER_LOAN}${data.loanNumber}/borrower/01`;

      const res = await client({
        url,
        method: "GET",
      });
      if (res?.data) {
        setData((prev) => ({
          ...prev,
          loanEmail: res.data.emailAddress,
          ssn: res.data.ssn,
        }));
        const certURL = `${res?.data?.firstName.toLowerCase()}${res?.data?.lastName.toLowerCase()}`;
        setInitialURL(certURL);
        setTempURL(certURL);
        clientResponse = res;
        return res;
      }
    } catch (err) {
      console.log(err);
      clientResponse = err;
    } finally {
      return clientResponse;
    }
  };

  // fetch loan details
  const fetchLoanDetails = async () => {
    const url = `${process.env.REACT_APP_SUNSOFT_RESTSERVER_LOAN}${data.loanNumber}`;

    const res = await client({
      url,
      method: "GET",
    });
    return res.data;
  };

  // const getBase64 = async (file) => {
  //   // eslint-disable-next-line func-names
  //   const pdfPromise = new Promise(function (resolve, reject) {
  //     const reader = new FileReader();
  //     reader.onload = function () {
  //       resolve(reader.result);
  //     };
  //     // eslint-disable-next-line no-shadow
  //     reader.onerror = (error) => reject(error);

  //     reader.readAsDataURL(file);
  //   });
  //   return pdfPromise;
  // };
  const modalTimeout = () => {
    setTimeout(() => {
      setModalText("");
      setLoading(false);
    }, 500);
  };
  // fetch the document
  const handleCapture = async () => {
    setLoading(true);
    setModalText(<>Please wait while we prepare your certificate.</>);
    let fileName;
    const isFileSaverSupported = !!new Blob();
    try {
      console.log("checking if canvas and ref exist");
      if (isFileSaverSupported && canvas) {
        console.log("canvas and ref exist");
        fileName = `${loan?.borrowerName || loan?.borrowerHeaderLine} - ${
          content.productName
        } Certificate.png`;

        console.log("start blob conversion process.");
        canvas.toBlob(
          (blob) => {
            console.log("start saving blob.");
            saveAs(blob, fileName);

            console.log("blob saved.");
          },
          "image/png",
          content.certificateQuality
        );
        setModalText("Success!");
      } else {
        if (!canvas) {
          throw new Error("canvas doesn't exist");
        } else if (!isFileSaverSupported) {
          throw new Error("Blob is not supported ");
        }
      }
    } catch (err) {
      console.log("saving certificate blob failed", err);
      try {
        console.log("starting dataURL Image");
        const errorCanvas = await html2canvas(captureRef.current);
        if (errorCanvas.style) {
          const dataURL = errorCanvas.toDataURL("image/png", 1);
          const dlLink = document.createElement("a");
          dlLink.download = `${
            loan?.borrowerName || loan?.borrowerHeaderLine
          } - ${content.productName} Certificate.png`;
          dlLink.href = dataURL;
          dlLink.click();
          setModalText("Success!");
        } else {
          setModalText(
            <>
              Something went wrong when creating your certificate, please try
              again.
            </>
          );
          throw new Error("canvas not mounted");
        }
      } catch (err) {
        console.log(err);
      }
    } finally {
      modalTimeout();
    }
  };

  const handleCanvasDataURL = useCallback(async () => {
    try {
      console.log("getting mounted canvas");
      let newCanvas = await html2canvas(captureRef.current);
      console.log("show canvas", newCanvas);
      if (newCanvas.style) {
        console.log("canvas exists");
        setCanvas(newCanvas);
        console.log("saved canvas");
      }
    } catch (err) {
      console.log("canvas save failed", err);
    }
  }, [captureRef, setCanvas]);

  // const downloadDoc = () => {
  //   const doc = window.URL.createObjectURL(new Blob([blob]));
  //   const link = document.createElement("a");
  //   link.href = doc;
  //   link.setAttribute(
  //     "download",
  //     `Financial_Soundness_Certificate_${data.firstName}${data.lastName
  //       .charAt(0)
  //       .toUpperCase()}.pdf`
  //   );

  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  const onSubmitFSS = async (e, userSSN) => {
    setModalText(<>Please Wait while we verify your identity.</>);
    e.preventDefault();
    if (userSSN.one && userSSN.two && userSSN.three && userSSN.four) {
      try {
        setLoading(true);
        const res = await authenticateUser();
        if (validateSSN(res.data.ssn, userSSN)) {
          setModalText(<>We are now checking the status of your loan.</>);
          console.log("validatecheck");
          const loanDetails = await fetchLoanDetails();
          const borrowerName = `${loanDetails?.b1FirstName
            .substring(0, 1)
            .toUpperCase()}${loanDetails?.b1FirstName
            .substring(1)
            .toLowerCase()} ${loanDetails?.b1LastName
            .substring(0, 1)
            .toUpperCase()}${loanDetails?.b1LastName
            .substring(1)
            .toLowerCase()}`;

          setLoan({
            ...loanDetails,
            loanAmount: loanDetails?.loanAmount,
            borrowerName,
          });

          setInitialURL(borrowerName.replace(" ", "").toLowerCase());
          setTempURL(borrowerName.replace(" ", "").toLowerCase());

          if (
            loanDetails.loanStatus.toLowerCase() === "pre-approval" ||
            loanDetails.loanStatus.toLowerCase() === "conditionally approved" ||
            loanDetails.loanStatus.toLowerCase() === "ready for docs" ||
            loanDetails.finalLoanStatusDescription
              .toLowerCase()
              .includes("approve") ||
            loanDetails.finalLoanStatusKeyword.toLowerCase().includes("approve")
          ) {
            console.log("passedcheck");
            setModalText(
              <>
                <p className="doc-text d-flex justify-content-center align-items-center">
                  Congrats! You have been approved. Please wait while we
                  retrieve your Certificate.
                </p>
              </>
            );
            setTimeout(() => {
              setModalText("");
              setLoading(false);
              setPageFour(true);
              setPageThree(false);
            }, 1000);
          }
        } else {
          setLoading(false);
          setError({
            status: true,
            message: "Last 4 of SSN does not match SSN on account.",
          });
        }
      } catch (err) {
        console.log(err);
        setLoading(false);
        setError({
          status: true,
          message: "Something went wrong, please try again.",
        });
      }
    } else {
      setError({
        status: true,
        message: "Please enter the last 4 digits of your SSN.",
      });
    }
  };

  const onSubmitTRU = async (e, userSSN) => {
    setModalText(<>Please Wait while we verify your identity.</>);
    e.preventDefault();
    if (userSSN.one && userSSN.two && userSSN.three && userSSN.four) {
      try {
        setLoading(true);
        const res = await authenticateUser();
        if (validateSSN(res.data.ssn, userSSN)) {
          setModalText(<>We are now checking the status of your loan.</>);
          console.log("validatecheck");
          const clientConfig = {
            url: process.env.REACT_APP_TRUAPPROVAL_LOAN.replace(
              "{loanNo}",
              data?.loanNumber
            ),
            method: "POST",
            body: {},
          };

          const {
            data: { truApprovalObjJson },
          } = await client(clientConfig);

          if (truApprovalObjJson?.validLoan) {
            console.log("passedcheck");
            setLoan({
              ...truApprovalObjJson,
              loanNumber: data.loanNumber,
              loanEmail: res.data.emailAddress,
            });

            setModalText(
              <>
                <p className="doc-text d-flex justify-content-center align-items-center">
                  Congrats! You have been approved. Please wait while we
                  retrieve your Certificate.
                </p>
              </>
            );
            setTimeout(() => {
              setModalText("");
              setLoading(false);
              setPageFour(true);
              setPageThree(false);
            }, 1000);
          }
        } else {
          setLoading(false);
          setError({
            status: true,
            message: "Last 4 of SSN does not match SSN on account.",
          });
        }
      } catch (err) {
        console.log(err);
        setLoading(false);
        setError({
          status: true,
          message: "Something went wrong, please try again.",
        });
      }
    } else {
      setError({
        status: true,
        message: "Please enter the last 4 digits of your SSN.",
      });
    }
  };

  const onSubmit = siteVersion ? onSubmitFSS : onSubmitTRU;

  const makePublic = useCallback(async () => {
    setLoading(true);
    setModalText(<>Please wait while we make your certificate public.</>);
    try {
      const body = {
        file: canvas.toDataURL("image/png"),
        name: `${urlTernary}.png`,
        pathname: process.env.REACT_APP_CERT_PATH,
        bucket: process.env.REACT_APP_CERT_BUCKET,
        url: `${metaUrl}/${urlTernary}`,
        thumbnail: metaThumbnail,
        description: getMetaDescription(loan),
        title: metaTitle,
      };
      const {
        data: { body: res },
      } = await axios.post(process.env.REACT_APP_CERTIFICATE_API, body, {
        headers: { "Content-Type": "application/json" },
      });
      if (res?.success) {
        const returnedName = res.success.name.replace(".png", "");
        setLoading(false);
        setModalText("");
        setPageFour(false);
        setPageFive(true);
        if (customURL) {
          setCustomURL(returnedName);
        } else {
          setInitialURL(returnedName);
        }
        setTempURL(returnedName);
      } else if (res?.error?.message) {
        setLoading(false);
        setModalText("");
        setPageFour(false);
        setPageFive(true);
        console.log(res?.error?.message);
      }
    } catch (err) {
      console.log(err);
      setModalText(<>Something went wrong, please try again.</>);
      setTimeout(() => {
        setLoading(false);
        setModalText("");
      }, 1000);
    }
  }, [canvas, customURL, urlTernary, loan]);

  const makePrivate = async () => {
    setLoading(true);
    setModalText(<>Please wait while we make your certificate private.</>);
    try {
      const body = {
        file: null,
        pathname: process.env.REACT_APP_CERT_PATH,
        bucket: process.env.REACT_APP_CERT_BUCKET,
        name: `${urlTernary}.png`,
        private: true,
      };
      const {
        data: { body: res },
      } = await axios.post(process.env.REACT_APP_CERTIFICATE_API, body, {
        headers: { "Content-Type": "application/json" },
      });
      if (res?.success) {
        setPageFour(true);
        setPageFive(false);
      } else if (res?.error?.message) {
        setPageFour(true);
        setPageFive(false);
      }
    } catch (err) {
      console.log(err);
      setModalText(<>Something went wrong, please try again.</>);
      setTimeout(() => {
        setLoading(false);
        setModalText("");
      }, 1000);
    } finally {
      setLoading(false);
      setModalText("");
    }
  };

  const makeDefaultPrivate = async () => {
    try {
      const body = {
        file: null,
        name: `${urlTernary}.png`,
        private: true,
        pathname: process.env.REACT_APP_CERT_PATH,
        bucket: process.env.REACT_APP_CERT_BUCKET,
      };
      await axios.post(process.env.REACT_APP_CERTIFICATE_API, body, {
        headers: { "Content-Type": "application/json" },
      });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (saveCustom) {
      makePublic();
      setSaveCustom(false);
    }
  }, [saveCustom, makePublic]);

  useEffect(() => {
    let timeoutId;

    const errorTimeout = () => {
      timeoutId = setTimeout(
        () => setError({ status: false, message: "" }),
        5000
      );
    };

    if (error.status) {
      errorTimeout();
    } else {
      clearTimeout(timeoutId);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [error.status]);

  return (
    <>
      {" "}
      <Helmet>
        <meta property="og:type" content="website" />
        <meta property="og:url" content={metaUrl} />
        <meta name="title" property="og:title" content={metaTitle} />
        <meta name="image" property="og:image" content={metaThumbnail} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="600" />
        <meta
          name="description"
          property="og:description"
          content={metaDescription}
        />
        <meta name="author" content="Sun West Mortgage Company, LLC" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content={metaUrl} />
        <meta name="twitter:title" content={metaTitle} />
        <meta name="twitter:description" content={metaDescription} />
        <meta name="twitter:image" content={metaThumbnail} />
        <meta
          name="keywords"
          content="Home Shopping, Dream House, Place offers, No Loan Contingency, Buying Power, Shop, Cash offers, Simple, Fast online application, TRU Approval®, TRU Approval® Difference, Empowering Homebuyer, Home Purchase, Get Started Online, Shop For Your Dream, Home, Homebuyer"
        />
        <title>{metaTitle}</title>
      </Helmet>
      <Header />
      <StyledFSS
        status={error.status}
        pageOne={pageOne}
        pageTwo={pageTwo}
        pageThree={pageThree}
        pageFour={pageFour}
        pageFive={pageFive}
      >
        {pageOne && (
          <PageOne
            data={data}
            setPageOne={setPageOne}
            setPageTwo={setPageTwo}
          />
        )}
        {pageTwo && (
          <PageTwo
            data={data}
            setPageTwo={setPageTwo}
            setPageThree={setPageThree}
            setError={setError}
            error={error}
          />
        )}
        {pageThree && (
          <PageThree setError={setError} error={error} onSubmit={onSubmit} />
        )}
        {(pageFour || pageFive) && (
          <PageFour
            publicToggle={publicToggle}
            setPublicToggle={setPublicToggle}
            makePublic={makePublic}
            loan={loan}
            pageFive={pageFive}
            captureRef={captureRef}
            handleCapture={handleCapture}
            handleCanvasDataURL={handleCanvasDataURL}
            makeDefaultPrivate={makeDefaultPrivate}
            setCustomURL={setCustomURL}
            setSaveCustom={setSaveCustom}
            setTempURL={setTempURL}
            tempURL={tempURL}
            customURL={customURL}
            initialURL={initialURL}
            makePrivate={makePrivate}
            urlTernary={urlTernary}
          />
        )}
        {/* {pageFive && (
          <PageFive
            makeDefaultPrivate={makeDefaultPrivate}
            setCustomURL={setCustomURL}
            setSaveCustom={setSaveCustom}
            publicToggle={publicToggle}
            setPublicToggle={setPublicToggle}
            setTempURL={setTempURL}
            tempURL={tempURL}
            customURL={customURL}
            initialURL={initialURL}
            makePrivate={makePrivate}
            loan={loan}
            data={data}
            canvas={canvas}
            urlTernary={urlTernary}
          />
        )} */}

        <div className="bottom-images"></div>
        {loading && (
          <Popup
            loading={loading}
            modalText={modalText}
            loadError={loadError}
          />
        )}
      </StyledFSS>
    </>
  );
};
export default Registration;
